// extracted by mini-css-extract-plugin
export default {"editorXToolBar":"ZTiLxX","logo":"K3kbj9","logoImage":"ErYpyS","switcher":"H15edh","button":"q6CGBc"};